// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/FivoSans-Bold-Oblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/FivoSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/FivoSans-Light-Oblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/fonts/FivoSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/fonts/FivoSans-Medium-Oblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/fonts/FivoSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/fonts/FivoSans-Oblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/fonts/FivoSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/fonts/FivoSans-Thin-Oblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/fonts/FivoSans-Thin.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */
body {
  /* font-family: "IBM Plex Sans", sans-serif; */
  background-color: #f5f5f5;
  margin: 0;
  padding: 0;
}

.App {
  text-align: center;
}

.button {
  background-color: #b51f25;
  border: none;
  color: white;
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

/* button:hover {
  background-color: #9e1c20;
} */

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

@font-face {
  font-family: "Fivo Sans Bold Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "Fivo Sans Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: "Fivo Sans Light Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: "Fivo Sans Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: "Fivo Sans Medium Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: "Fivo Sans Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: "Fivo Sans Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: "Fivo Sans Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: "Fivo Sans Thin Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: "Fivo Sans Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,4CAAqD;AACvD;;AAEA;EACE,6BAA6B;EAC7B,4CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,4CAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,4CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,4CAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,4CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,4CAAgD;AAClD;;AAEA;EACE,gCAAgC;EAChC,4CAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,4CAAqD;AACvD;;AAEA;EACE,6BAA6B;EAC7B,4CAA6C;AAC/C","sourcesContent":["/* src/index.css */\nbody {\n  /* font-family: \"IBM Plex Sans\", sans-serif; */\n  background-color: #f5f5f5;\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  text-align: center;\n}\n\n.button {\n  background-color: #b51f25;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  margin: 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\n/* button:hover {\n  background-color: #9e1c20;\n} */\n\n.navigation-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n@font-face {\n  font-family: \"Fivo Sans Bold Italic\";\n  src: url(\"../public/fonts/FivoSans-Bold-Oblique.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Bold\";\n  src: url(\"../public/fonts/FivoSans-Bold.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Light Italic\";\n  src: url(\"../public/fonts/FivoSans-Light-Oblique.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Light\";\n  src: url(\"../public/fonts/FivoSans-Light.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Medium Italic\";\n  src: url(\"../public/fonts/FivoSans-Medium-Oblique.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Medium\";\n  src: url(\"../public/fonts/FivoSans-Medium.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Italic\";\n  src: url(\"../public/fonts/FivoSans-Oblique.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Regular\";\n  src: url(\"../public/fonts/FivoSans-Regular.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Thin Italic\";\n  src: url(\"../public/fonts/FivoSans-Thin-Oblique.otf\");\n}\n\n@font-face {\n  font-family: \"Fivo Sans Thin\";\n  src: url(\"../public/fonts/FivoSans-Thin.otf\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
